import React from 'react';
import { MapPinIcon, MailIcon, GlobeIcon } from 'lucide-react';
export function ContactCard() {
  return <div className="mt-8 rounded-xl bg-white p-8 md:p-10 shadow-card border border-slate-light/50" data-id="element-1">
      <p className="font-sans text-sm font-semibold text-sky mb-3 uppercase" style={{
      letterSpacing: '0.08em'
    }} data-id="element-2">
        Get in touch
      </p>
      <h3 className="font-sans text-2xl font-semibold text-navy mb-1 leading-tight" data-id="element-3">
        WinePik Pty Ltd
      </h3>
      <p className="text-sm text-stone mb-6 font-medium" data-id="element-4">ABN 56 694 172 480</p>

      <div className="space-y-4 text-[16px]" data-id="element-5">
        <div className="flex items-start gap-3" data-id="element-6">
          <MapPinIcon className="w-5 h-5 text-sky mt-0.5 shrink-0" strokeWidth={2} aria-hidden="true" data-id="element-7" />
          <span className="text-slate" data-id="element-8">
            340 Sandy Creek Rd, Riddells Creek VIC 3431, Australia
          </span>
        </div>
        <div className="flex items-start gap-3" data-id="element-9">
          <MailIcon className="w-5 h-5 text-sky mt-0.5 shrink-0" strokeWidth={2} aria-hidden="true" data-id="element-10" />
          <a href="mailto:privacy@winepik.io" className="text-sky font-medium hover:text-sky-hover hover:underline underline-offset-[3px] transition-colors" data-id="element-11">
            privacy@winepik.io
          </a>
        </div>
        <div className="flex items-start gap-3" data-id="element-12">
          <GlobeIcon className="w-5 h-5 text-sky mt-0.5 shrink-0" strokeWidth={2} aria-hidden="true" data-id="element-13" />
          <a href="https://winepik.io" className="text-sky font-medium hover:text-sky-hover hover:underline underline-offset-[3px] transition-colors" data-id="element-14">
            winepik.io
          </a>
        </div>
      </div>
    </div>;
}